<div class="pt-3 info-list has-info-icon" [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'Facebook'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'facebookRating' : getRating(data?.socialMedia?.facebookRating)}"
                          [value]="data?.socialMedia?.facebookRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'LinkedIn'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'linkedInRating' : getRating(data?.socialMedia?.linkedInRating)}"
                          [value]="data?.socialMedia?.linkedInRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Twitter'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'twitterRating' : getRating(data?.socialMedia?.twitterRating)}"
                          [value]="data?.socialMedia?.twitterRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Social Traffic %'"
                          [type]="'percent'"
                          [value]="data?.socialMedia?.socialTotalTrafficRatio"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="invisible">
    <ng-container *ngIf="isFreemium">
      <div class="divider" style="height: 84px;"></div>
    </ng-container>
    <ng-container *ngIf="!isFreemium">
      <div class="divider" style="height: 56px;"></div>
    </ng-container>
  </div>
</div>
